export default "__VITE_ASSET__bcc27fdc__"